import * as THREE from 'three';
import Action from '../classes/Action';
import {GroupsManager} from '../classes/GroupsManager';
import { CustomEventTypes } from '../globals';
import { areArraysEqual } from '../classes/utilities/Misc';

export default class SetObjectGroupsAction extends Action
{
	constructor(objects: THREE.Object3D[], newGroupsGuids: string[])
	{
		const initialGroupGUids: Map<number, string[]> = new Map();

		for(let i = 0; i < objects.length; i++)
		{
			const object = objects[i];
			initialGroupGUids.set(i, object.userData.groups ? [...object.userData.groups] as string[] : []);
		}

		super(
			[objects, newGroupsGuids],
			[objects, initialGroupGUids],
			"Set Groups for " + objects.length + " objects",
			[objects, newGroupsGuids, initialGroupGUids]);
	}

	do(objects: THREE.Object3D[], groupGuids: string[]) : void
	{
		for (let i = 0; i < objects.length; i++)
		{
			const object = objects[i];
			if(object.userData.groups)
			{
				const groupsToRemove = [...object.userData.groups];

				for (const groupGuid of groupsToRemove)
				{
					GroupsManager.removeFromGroup(groupGuid, [object]);
				}
			}
			
			for (const groupGuid of groupGuids)
			{
				GroupsManager.addToGroup(groupGuid, [object]);
			}
		}

		document.dispatchEvent(new CustomEvent(CustomEventTypes.updatePropertiesComponent));
	}

	undo(objects: THREE.Object3D[], initialGroups: Map<number, string[]>) : void
	{
		for (let i = 0; i < objects.length; i++)
		{
			const object = objects[i];
			const groupsToRemove = [...object.userData.groups];

			for (const groupGuid of groupsToRemove)
			{
				GroupsManager.removeFromGroup(groupGuid, [object]);
			}

			for (const groupGuid of initialGroups.get(i)!)
			{
				GroupsManager.addToGroup(groupGuid, [object]);
			}
		}

		document.dispatchEvent(new CustomEvent(CustomEventTypes.updatePropertiesComponent));
	}

	verify(objects: THREE.Object3D[], newGroupGuids: string[], initialGroups: Map<number, string[]>) : boolean
	{
		for(let i = 0; i < objects.length; i++)
		{
			if(!areArraysEqual([...newGroupGuids].sort(), [...initialGroups.get(i)!].sort())) return true;
		}

		return false;

	}
}
